import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdminFormGroup } from "@myapp/features/admin/models";
import { ModalOptions } from '@myapp/features/widgets/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-base-editor',
  templateUrl: './base-editor.component.html'
})
export abstract class BaseEditorComponent implements OnInit {
  @Input() options: ModalOptions = new ModalOptions();
  private _isDirty: boolean = false;
  @Output() isDirtyChanged = new EventEmitter<boolean>();

  abstract form?: AdminFormGroup;

  constructor(private modal: NgbActiveModal) { }

  ngOnInit() {
    this.form?.valueChanges.subscribe((event: any) => {
      this.isDirty = true;
      this.isDirtyChanged.emit(true);
    });
  }

  canSave() {
    return this.isDirty && !this.form?.invalid;
  }

  get isDirty(): boolean {
    return this._isDirty;
  }

  private set isDirty(value: boolean) {
    this._isDirty = value;
  }

  public onCancel() {
    this.modal.dismiss('Cancelled');
  }

  public onSave() {
    this.modal.close(this.form!.getItem());
  }
}
